// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__OVvyO","icon-orange":"icon_icon-orange__oGakr","icon-black":"icon_icon-black__K9g4M","icon-silver":"icon_icon-silver__ObQWu","icon-white":"icon_icon-white__Q9g+E"};